import api from '@/api'

const namespaced = true

const state = {
  permissions: []
}

const getters = {
  permissions: state => state.permissions
}

const mutations = {
  SET_PERMISSIONS: (state, payload) => {
    state.permissions = payload
  }
}

const actions = {
  async fetchPermissions({ commit }, payload) {
    try {
      const id = payload.id
      delete payload.id

      const { data } = await api.getPermissionByGroup(id, payload)
      if (data.error) {
        commit('SET_PERMISSIONS', [])
        return
      }

      commit('SET_PERMISSIONS', data)
    } catch (err) {
      throw err
    }
  },
  async putPermissions(_, payload) {
    try {
      const id = payload.id
      const form = payload.data

      await api.putPermission(id, form)
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }
